<template>
  <b-breadcrumb :items="items" />
</template>

<script>
export default {
  props: ["items"],
};
</script>
